import * as STD          from '@emersya/mpa-std-lib';
import CM                from '@emersya/mpa-components-manager-lib';
import { InputButton }   from '@emersya/mpa-components-lib';
import * as BasketNS     from '@emersya/mpa-basket-lib';

export interface IProductTileComponentConfiguration extends InputButton.Configuration {
	SKU : string;
	viewerCode : string;
	iconURL : string;
	basketProduct : BasketNS.Product;
};

export class ProductTileComponent extends InputButton.Component {
	static override getInputEventSubType() {
		const parentClass = (<(typeof CM.Component) []> <any> STD.object.getInheritanceChainFromClass(this))[ 1 ];
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button');
		}
		return parentClass.type;
	};

	static override initialize() {
		super.initialize();
	};

	// component_DOM : HTMLDivElement;
	basketProduct : object;

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IProductTileComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.basketProduct = configuration.basketProduct;
		// if (this.component_hasTranslation('name')) {
		// 	this.component_DOM.appendChild(STD.DOM.factory({
		// 		dataset : {
		// 			'translation' : <string> this.component_getTranslationId('name')
		// 		}
		// 	}));
		// } else {
		// 	this.component_DOM.appendChild(STD.DOM.factory({
		// 		text : configuration.SKU
		// 	}));
		// }
		// this.component_DOM.appendChild(STD.DOM.factory({
		// 	tag : 'img',
		// 	attributes : {
		// 		'src' : configuration.iconURL
		// 	},
		// 	// dataset : {
		// 	// 	'translation-attr' : 'alt:' + <string> this.component_getTranslationId('name')
		// 	// }
		// }));
		// See image component on how to use translations.
	};
};
export namespace NS {
	export const Component = ProductTileComponent;
	export type Component = ProductTileComponent;
	export type Configuration = IProductTileComponentConfiguration;
}
;
import manifestXMLSource from './ProductTile.xml';
import './ProductTile.scss';

CM.declare({
	id :       'product-tile',
	type :     ProductTileComponent,
	manifest : manifestXMLSource
});
